<template>
    <ts-card>
        <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
            <h4 class="ts-text-sm">{{ $t('eventManagement.previewQr') }}</h4>
            <ts-modal-close-button />
        </div>

        <ts-loading-banner :loading="loading">
            <ts-card-wrapper>
                <div class="d-flex flex-column justify-content-center align-items-center" style="height: 70vh;">
                    <!-- QR Image -->
                    <img :src="urlImage" class="rounded-lg shadow-lg mb-3"
                        style="max-width: 90%; max-height: 60vh; width: auto; height: auto;" />

                    <ts-button color="primary" @click.prevent="download(urlImage)">
                        <i class="fa fa-download mr-2"></i>
                        {{ $t('Download QR') }}
                    </ts-button>
                </div>
            </ts-card-wrapper>
        </ts-loading-banner>
    </ts-card>
</template>
<script>
import Vue from 'vue'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
Vue.use(VueViewer)
import * as FileDownload from 'downloadjs'
export default {
    name: 'previewQr',
    props: {
        event_mgt_id: {
            type: Number
        }
    },
    data() {
        return {
            iconSize: 'fa-2x',
            loading: false,
            urlImage: ''
        }
    },
    created() {
        this.previewCardQr()
    },
    methods: {
        previewCardQr() {
            this.loading = true
            this.$store
                .dispatch('eventManagement/generateQr', {
                    event_mgt_id: this.event_mgt_id
                })
                .then(response => {
                    this.$toasted.success(response.message)
                    this.loading = false
                    this.urlImage = response.url_images
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                    this.loading = true
                })
        },
        download(url) {
            FileDownload(url)
        }
    }
}
</script>
